import router from './router'

const axios = require('axios')

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.request.use(config => {
  return config
}, function(error) {
  return Promise.reject(error)
})

axiosInstance.interceptors.response.use(response => {
  return response
}, error => {
  //認証エラーの時にログアウト状態にしログイン画面にリダイレクト
  if (error.response.status === 401) {
    localStorage.loggedIn = 0
    localStorage.employeeName = null
    router.push({name: 'Login'})
  }
  return Promise.reject(error)
})

export default axiosInstance
